module.exports = __webpack_public_path__ + "df2f7f06592af8555f598edc656f3599.svg";